import { jsx as _jsx } from "react/jsx-runtime";
import { AddCircle } from "@mui/icons-material";
import { Button } from "@mui/material";
export const AddEntityButton = (props) => (_jsx(Button, { variant: "text", color: "primary", startIcon: _jsx(AddCircle, {}), sx: { mt: 2 }, ...props, children: props.text }));
